'use client';

import Link from 'next/link';
import {
  HomeLine,
  User01,
  Star01,
  Settings02,
  LifeBuoy02
} from '@goodneighbor/ui/icons/untitled';
import styles from './campaignHeader.module.scss';
import { AccountResponse } from '@goodneighbor/api/schemas/account';
import { accountHasRoles } from '@goodneighbor/roles';

export function PartnerDesktopMenuItems({
  account
}: {
  account?: AccountResponse | void;
}) {
  const hasAllLinksAccess = accountHasRoles({
    account,
    operation: 'OR',
    requiredRoles: ['PARTNER_ACCOUNT_OWNER', 'PARTNER_MANAGER']
  });

  if (!hasAllLinksAccess) {
    return null;
  }

  return (
    <Link href="/partner/dashboard" className={styles.accountMenuItem}>
      Dashboard
    </Link>
  );
}

export function PartnerMobileNavItems({
  onNavigate,
  account
}: {
  onNavigate: () => void;
  account?: AccountResponse | void;
}) {
  const hasAllLinksAccess = accountHasRoles({
    account,
    operation: 'OR',
    requiredRoles: ['PARTNER_ACCOUNT_OWNER', 'PARTNER_MANAGER']
  });

  return (
    <>
      <ul className={styles.mobileNavList}>
        {hasAllLinksAccess && (
          <li>
            <Link
              href="/partner/dashboard"
              className={styles.mobileNavLinkWithIcon}
              onClick={onNavigate}
            >
              <HomeLine className={styles.mobileNavIcon} />
              Home
            </Link>
          </li>
        )}
        {hasAllLinksAccess && (
          <li>
            <Link
              href="/partner/dashboard/volunteers"
              className={styles.mobileNavLinkWithIcon}
              onClick={onNavigate}
            >
              <User01 className={styles.mobileNavIcon} />
              Volunteers
            </Link>
          </li>
        )}
        <li>
          <Link
            href="/partner/dashboard/events"
            className={styles.mobileNavLinkWithIcon}
            onClick={onNavigate}
          >
            <Star01 className={styles.mobileNavIcon} />
            Events
          </Link>
        </li>
        <li>
          <Link
            href="/partner/dashboard/account"
            className={styles.mobileNavLinkWithIcon}
            onClick={onNavigate}
          >
            <Settings02 className={styles.mobileNavIcon} />
            Account
          </Link>
        </li>
      </ul>
      <div className={styles.mobileNavDivider} />
      <ul className={styles.mobileNavList}>
        <li>
          <a
            href="mailto:partner@goodneighbordayamerica.com"
            className={styles.mobileNavLinkWithIcon}
            onClick={onNavigate}
          >
            <LifeBuoy02 className={styles.mobileNavIcon} />
            Support
          </a>
        </li>
      </ul>
    </>
  );
}
